export default __webpack_public_path__ + "static/media/listopad.bef0e5fb.mp3";